import { isOrganizationScopedNotification } from "@workspace/dto/notification/definitions";
import type { NotificationDto } from "@workspace/dto/notification/schema";

export type ConversationEndedPayload = {
  conversationId: string;
  closedAt: string | Date;
  closedBy: { id: string; name?: string | null };
  organizationId?: string;
};

type RealtimeUserType = "employee" | "employer" | string;

export function shouldAcceptRealtimeNotification({
  notification,
  organizationId,
  userType,
}: {
  notification: NotificationDto;
  organizationId?: string;
  userType?: RealtimeUserType;
}) {
  if (userType !== "employer") {
    return true;
  }
  if (!isOrganizationScopedNotification(notification.type)) {
    return true;
  }
  return notification.organization === organizationId;
}

export function shouldAcceptRealtimeConversationEvent({
  organizationId,
  payload,
  userType,
}: {
  organizationId?: string;
  payload: ConversationEndedPayload;
  userType?: RealtimeUserType;
}) {
  return userType !== "employer" || payload.organizationId === organizationId;
}
